var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import UserCompletedVerification from './UserCompletedVerification';
import UserVerification from './UserVerification';
import UserPendingVerification from './UserPendingVerification';
import Persona from './Persona';
import { getStatus } from '../../../api/KYC';
import HomeVerification from '../../home/HomeVerification';
import { Flex, Loader } from '@homeexchange/design';
import i18n from '../../../i18n';
import { getRedirectTo } from '../../../utils/verificationRedirect';
var Verification = function (_a) {
    var type = _a.type, user = _a.user, auth = _a.auth;
    var _b = useState({
        showPersona: false,
        verificationStatus: null,
        isLoading: false,
        isCompleted: false
    }), flow = _b[0], setFlow = _b[1];
    var hideHeaderAndFooter = function () {
        var _a;
        document.querySelectorAll('.navbar-right').forEach(function (e) { return e.classList.add('hidden'); });
        (_a = document.querySelector('.global-footer')) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
    };
    var getHomeIdFromUrl = function () {
        if (type !== 'HOME') {
            return null;
        }
        var pathParts = window.location.pathname.split('/').filter(Boolean);
        var lastPart = pathParts[pathParts.length - 1];
        var homeId = Number.parseInt(lastPart, 10);
        return Number.isNaN(homeId) ? null : homeId;
    };
    var isHomeVerification = function () { return type === 'HOME'; };
    var isPendingVerification = function (_a) {
        var _b;
        var identity = _a.identity, poa = _a.poa;
        return (identity === null || identity === void 0 ? void 0 : identity.verification_status) === 'NEEDS_REVIEW' ||
            (identity === null || identity === void 0 ? void 0 : identity.verification_status) === 'REJECTED_FRAUDULENT_USER' ||
            ((_b = poa === null || poa === void 0 ? void 0 : poa.homes) === null || _b === void 0 ? void 0 : _b.some(function (home) {
                return home.verification_status === 'NEEDS_REVIEW' ||
                    home.verification_status === 'REJECTED_FRAUDULENT_USER';
            }));
    };
    var hasUnverifiedHome = function (_a) {
        var _b;
        var poa = _a.poa;
        return (_b = poa === null || poa === void 0 ? void 0 : poa.homes) === null || _b === void 0 ? void 0 : _b.some(function (home) { return !home.is_verified; });
    };
    var isUserVerified = function (_a) {
        var identity = _a.identity;
        return identity === null || identity === void 0 ? void 0 : identity.is_verified;
    };
    var handleShowPersona = function () { return setFlow(__assign(__assign({}, flow), { showPersona: true })); };
    var handleOnCompleted = function () {
        var redirectTo = getRedirectTo();
        if (redirectTo) {
            window.location.assign(redirectTo);
            return;
        }
        setFlow(__assign(__assign({}, flow), { isCompleted: true, showPersona: false }));
    };
    var getVerificationStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var status_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setFlow(__assign(__assign({}, flow), { isLoading: true }));
                    return [4 /*yield*/, getStatus()];
                case 1:
                    status_1 = _a.sent();
                    setFlow(__assign(__assign({}, flow), { verificationStatus: status_1, isLoading: false }));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getVerificationStatus();
    }, [auth, flow.isCompleted]);
    useEffect(function () {
        if (!flow.isLoading &&
            flow.verificationStatus &&
            isHomeVerification() &&
            flow.isCompleted &&
            (isUserVerified(flow.verificationStatus) || !hasUnverifiedHome(flow.verificationStatus))) {
            window.location.href = i18n.t('user:user.verif.url');
        }
    }, [flow.verificationStatus, flow.isCompleted, flow.isLoading]);
    useEffect(function () {
        hideHeaderAndFooter();
    }, []);
    if (flow.isLoading || !user || !flow.verificationStatus) {
        return (React.createElement(Flex, { style: { height: 'calc(100vh - 80px)' }, isFullHeight: true, alignItems: "center", justifyContent: "center" },
            React.createElement(Loader, { size: "large" })));
    }
    if (isPendingVerification(flow.verificationStatus)) {
        return React.createElement(UserPendingVerification, null);
    }
    if (flow.showPersona) {
        var homeId = getHomeIdFromUrl();
        return (React.createElement(Persona, { status: flow.verificationStatus, homeToVerify: homeId, onComplete: handleOnCompleted }));
    }
    if (isHomeVerification() && hasUnverifiedHome(flow.verificationStatus)) {
        return React.createElement(HomeVerification, { user: user, showPersona: handleShowPersona });
    }
    if (isUserVerified(flow.verificationStatus)) {
        return React.createElement(UserCompletedVerification, { user: user });
    }
    return React.createElement(UserVerification, { user: user, auth: auth, showPersona: handleShowPersona });
};
var mapStateToProps = function (state) { return ({
    user: state.user,
    auth: state.auth
}); };
export default connect(mapStateToProps, null)(Verification);
